/** Brand coral: the ONE definition of a school event's colour on the in-app calendars (`getEventTypeColor` reads it too). */
export const EVENT_CALENDAR_COLOR = '#FFAE9E';
